import styles from './downloadHoardStatusPDFModal.module.css'
import { fileHelpers, usePDFActions } from "../../../../../features/files"
import { Modal, ModalId } from "../../../../../features/ui"
import { HoardOrder } from "../../../state/types"
import { FileTile, FileType } from "../../../../../features/ui"
import { useEffect, useState } from "react"
import { HoardStatusPDF } from '../hoard-status/hoardStatusPDF'

type Props = {
    hoard?: HoardOrder
}

export const DownloadHoardStatusPDFModal = (props: Props) => {
    const { hoard } = props

    const [pdfName, setPdfName] = useState<string>()

    const { hoardStatusFileName } = fileHelpers

    const { generatePDF, printPDF, isPrinting } = usePDFActions()

    useEffect(() => {
        hoard && setPdfName(hoardStatusFileName(hoard.code))
    }, [hoard])

    const pdfId = 'hoard-status-pdf'

    const onSubmit = () => {
        pdfName && generatePDF(pdfId, pdfName)
    }

    const renderHiddenPDF = () => hoard ? (
        <div className={styles.hidden}>
            <HoardStatusPDF
                id={pdfId}
                hoard={hoard}
            />
        </div>
    ) : <></>

    return (
        <Modal
            modalId={ModalId.DOWNLOAD_HOARD_STATUS_PDF}
            title="Descargar Estado de Acopio"
            submitLabel="Descargar"
            submitIcon="download"
            onSubmit={onSubmit}
            secondaryLabel="Imprimir"
            secondaryIcon="printer"
            disableSecondary={isPrinting || !pdfName}
            onSecondarySubmit={() => printPDF(pdfId)}
        >
            <FileTile fileType={FileType.PDF} fileName={pdfName}/>
            {renderHiddenPDF()}
        </Modal>
    )
}
